import React, { FC } from 'react';
import UsersListPage from './user-list';
import UserDetailsPage from './user-details';
import { Route, Routes } from 'react-router-dom';

const UsersIndex: FC = () => {
  return (
    <Routes>
      <Route path={`/*`} element={<UsersListPage />} />
      <Route path={`/:id`} element={<UserDetailsPage />} />
    </Routes>
  );
};

export default UsersIndex;
